import { t as reassign } from "./reassign.js";
import { mutationOptions, useMutation } from "@tanstack/react-query";
//#region src/__generated__/internal/approval/hooks/useReassign.ts
const reassignMutationKey = () => [{ url: "/api/mdm/internal/api/internal/requests/:requestId/assignments/:slot" }];
function reassignMutationOptions(config = {}) {
	const mutationKey = reassignMutationKey();
	return mutationOptions({
		mutationKey,
		mutationFn: async ({ path, body }) => {
			const { data } = await reassign({
				...config,
				path,
				body,
				throwOnError: true
			});
			return data;
		}
	});
}
/**
* @description Меняет исполнителя в уже занятом слоте, статус заявки при этом не меняется
* (отпуск, болезнь, ошибка назначения). Право переназначать слот принадлежит
* роли, которая заполняет его при переходе: NG_STAFF — Секретарь НГ,
* NTP_HEAD — Аппарат НГ, NTP_RESPONSIBLE — Начальник НТП. Роль назначаемого
* проверяется в Keycloak, как и при переходе; несоответствие — 409
* ASSIGNEE_ROLE_MISMATCH. Первичное назначение выполняется переходом статуса,
* а не этим методом — если слот ещё не занят, ответ 409 ASSIGNMENT_NOT_FOUND.
* @summary Переназначить слот участника
* {@link /api/mdm/internal/api/internal/requests/:requestId/assignments/:slot}
*/
function useReassign(options = {}) {
	const { mutation = {}, client: config = {} } = options ?? {};
	const { client: queryClient, ...mutationOptions } = mutation;
	const mutationKey = mutationOptions.mutationKey ?? reassignMutationKey();
	const baseOptions = reassignMutationOptions(config);
	return useMutation({
		...baseOptions,
		mutationKey,
		...mutationOptions
	}, queryClient);
}
//#endregion
export { reassignMutationOptions as n, useReassign as r, reassignMutationKey as t };

//# sourceMappingURL=useReassign.js.map